<template>
  <section class="content">
    <div class="col-md-3" v-if="this.user.roleName == 'Super Admin'">
      <div class="panel">
        <div class="panel-body">
          <div class="row dash-box">
            <div class="col-sm-8">
              <p class="number">{{ userCount }}</p>
              <p>User</p>
            </div>
            <div class="col-sm-4">
              <img
                src="/static/img/user.png"
                alt="Logo"
                style="margin-left: -19px"
              />
            </div>
          </div>
        </div>
        <router-link :to="{ name: 'Users' }">
          <div class="panel-footer bg-primary">
            More Info <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>
        </router-link>
      </div>
    </div>

    <div class="total_investment_wrp">
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p class="number">
                  {{ investedAmount ? investedAmount : '0' }}
                </p>
                <p>Total Investment Amount</p>
              </div>
              <div class="col-sm-4">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p class="number">
                  {{ totalInvestmentAmount ? totalInvestmentAmount : '0' }}
                </p>
                <p>Current Investment Value</p>
              </div>
              <div class="col-sm-4" v-if="totalInvestmentAmount !== 'No data'">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p
                  class="number"
                  :class="{
                    positive: netProfitAndLoss > 0,
                    negative: netProfitAndLoss < 0,
                  }"
                >
                  {{ netProfitAndLoss ? netProfitAndLoss : '0' }}
                </p>
                <p>Unrealised Profit/Loss</p>
              </div>
              <div class="col-sm-4" v-if="netProfitAndLoss !== 'No data'">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8" v-if="net_pnl">
                <p
                  class="number"
                  :class="{ positive: net_pnl > 0, negative: net_pnl < 0 }"
                >
                  {{ net_pnl ? net_pnl : '0' }}
                </p>
                <p>Net Profilt/Loss</p>
              </div>
            
              <div class="col-sm-4" v-if="net_pnl !== 'No data'">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p
                  class="number"
                  :class="{
                    positive: net_profit_percentage > 0,
                    negative: net_profit_percentage < 0,
                  }"
                >
                  {{
                    net_profit_percentage === 'No data'
                      ? net_profit_percentage
                      : `${net_profit_percentage}%`
                  }}
                </p>
                <p>Net Profit/Loss %</p>
              </div>
              <div class="col-sm-4" v-if="net_profit_percentage !== 'No data'">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="this.user.roleName == 'Admin'">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p class="number">
                  {{ withdrawlAmount ? withdrawlAmount : '0' }}
                </p>
                <p>Withdrawl Amount</p>
              </div>
              <div class="col-sm-4">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -19px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tablewrp">
      <div class="col-md-12" v-if="this.user.roleName == 'Admin'">
      <h3 >Investment History</h3>
        <table class="table table-bordered" >
          <thead>
            <tr>
              <th>Date</th>
              <th>Current Investment Value ($)</th>
              <th>Unrealised Profit/Loss ($)</th>
              <th>Net Profit/Loss ($)</th>
              <th>Net Profit/Loss %</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in history_table" v-if='history_table.length >0'>
              <td>
                {{
                  data.createdAt
                    
                }}
              </td>
              <td>
                {{
                  data.current_investment_value
                   
                }}
              </td>
              <td>{{ data.pnl_value ? data.pnl_value : '0' }}</td>
              <td>{{ data.net_pnl ? data.net_pnl : '0' }}</td>
              <td>
                {{
                  data.net_profit_percentage ? `${data.net_profit_percentage}%` : '0'
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <h4 v-if='history_table.length ===0' class="teext">No Investment History Found</h4>
      </div>
    </div>
  </section>
</template>

<script>
import {
  formService,
  eventBus,
  siteService,
  tripService,
  vehicleService,
  driverService,
  tripRouteService,
  deviceService,
  regionService,
  reportgenerationService,
  schedulereportService,
  investmentService,
} from '../../../services';
import { EVENTS } from '../../../config';
import { USER_ROLES } from '../../../config';
import { mapState } from 'vuex';
import moment from 'moment';
export default {
  name: 'dashboard',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      trip: {},
      upComingTripCount: '',
      vehicleCount: '',
      driverCount: '',
      driversCount: '',
      routesCount: '',
      deviceCount: '',
      regionCount: '',
      onGoingTripCount: '',
      completedTripCount: '',
      generatedReportCount: '',
      scheduleReportCount: '',
      salesDataCount: '',
      schedulesExpiryCount: '',
      userCount: '',
      totalInvestmentAmount: '',
      investedAmount: '',
      netProfitAndLoss: '',
      currentValue: '',
      net_pnl: '',
      net_profit_percentage: '',
      userData: null,
      withdrawlAmount: '',
      historyTableData: [],
      history_table:[]
    };
  },
  mounted: function() {
    this.getUser();
    //this.getData();
  },
  methods: {
    getListPnL() {
      this.loading = true;
      let data = this.user._id;
      return investmentService.getListPnLAll(data).then(
        response => {
          this.history_table = [];
          if (response.data === []) {
            this.history_table = [];
          } else {
            response.data.data.forEach(element => {
              this.history_table.push({
                withdrawl_amount: element.withdrawl_amount ?(element.withdrawl_amount).toFixed(2): 0,
                createdAt: moment(element.createdAt).format('DD-MM-YYYY '),
                current_investment_value: (element.current_investment_value).toFixed(2),
                pnl_value: (Number(element.pnl_value)).toFixed(2),
                net_profit_percentage:(element.net_profit_percentage).toFixed(2),
                net_pnl:(element.net_pnl).toFixed(2)
              });
            });
          }
        },
        err => {
          this.loading = false;
        },
      );
    },
    getData() {
      this.totalInvestmentAmount = this.userData.current_investment_value
        ? (this.userData.current_investment_value).toFixed(2)
        : 'No data';
      this.netProfitAndLoss = this.userData.pnl_value
        ? (Number(this.userData.pnl_value)).toFixed(2)
        : 'No data';
      this.investedAmount = this.userData.invested_amount;
      this.withdrawlAmount =
        this.userData.withdrawl_amount !== undefined
          ? this.userData.withdrawl_amount
          : 0;
      this.net_pnl =
        this.userData.current_investment_value &&
        this.userData.pnl_value &&
        this.userData.invested_amount
          ? (
              this.userData.current_investment_value +
              this.withdrawlAmount +
              Number(this.userData.pnl_value) -
              this.userData.invested_amount
            ).toFixed(2)
          : 'No data';
      this.net_profit_percentage =
        this.userData.current_investment_value &&
        this.userData.pnl_value &&
        this.userData.invested_amount
          ? (
              ((this.userData.current_investment_value +
                this.withdrawlAmount +
                Number(this.userData.pnl_value) -
                this.userData.invested_amount) /
                this.userData.invested_amount) *
              100
            ).toFixed(2)
          : 'No data';
      const intValue = parseInt(this.netProfitAndLoss, 10);
      if (0 > intValue) {
        this.currentValue =
          this.totalInvestmentAmount - this.investedAmount + intValue;
      } else {
        this.currentValue =
          this.totalInvestmentAmount - this.investedAmount + intValue;
      }
    },
    getUser() {
      this.loading = true;
      const params = {};
      params.$limit = 9999999;
      params.$page = 1;
      params.invisible = false;
      if (this.user.roleName == 'Admin') {
        params._id = this.user._id;
      }
      let routesList = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.userData = res.data.docs[0];
          this.userCount = res.data.items.total;
          this.getData();
          this.getListPnL();
        })
        .catch(error => {
          this.loading = false;
          console.error('routes.requestFunction-error:', error);
        });
    },
    getLiveTrips() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'ongoing';
      let tripList = [];
      this.$tripDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.onGoingTripCount = res.data.items.total;
          console.log(this.onGoingTripCount);
        })
        .catch(error => {
          this.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          // this.$snotify.error('Get live trip list failed', 'Error!')
        });
    },
    getUpComingTrip() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'scheduled';
      let tripList = [];
      this.$tripDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.upComingTripCount = res.data.items.total;
          console.log(this.upComingTripCount);
        })
        .catch(error => {
          this.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          // this.$snotify.error('Get upcoming trip list failed', 'Error!')
        });
      console.log('------------');
      console.log(Date.now());
      console.log(moment(Date.now()).format('hh:mm A'));
    },
    getCompletedTrips() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'completed';
      let tripList = [];
      this.$tripDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.completedTripCount = res.data.items.total;
        })
        .catch(error => {
          this.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          // this.$snotify.error('Get vehicle list failed', 'Error!')
        });
    },
    getVehicle() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      // params.status = 'Up-Coming';
      let vehicleList = [];
      this.$vehicleDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.vehicleCount = res.data.items.total;
        })
        .catch(error => {
          this.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          // this.$snotify.error('Get vehicle list failed', 'Error!')
        });
    },
    getDriver() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      // params.status = 'Up-Coming';
      let driverList = [];
      this.$expiringLicenseDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.driverCount = res.data.expiringCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('driver.requestFunction-error:', error);
          // this.$snotify.error('Get driver list failed', 'Error!')
        });
    },
    getRoutes() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      let routesList = [];
      this.$triprouteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.routesCount = res.data.items.total;
        })
        .catch(error => {
          this.loading = false;
          console.error('routes.requestFunction-error:', error);
          // this.$snotify.error('Get routes list failed', 'Error!')
        });
    },
    getDevices() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      this.$driverDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.driversCount = res.data.items.total;
        })
        .catch(error => {
          this.loading = false;
          console.error('device.requestFunction-error:', error);
          // this.$snotify.error('Get device list failed', 'Error!')
        });
    },
    getRegion() {
      this.loading = true;
      const params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionManager = this.user._id;
      }
      this.$regionDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.regionCount = res.data.items.total;
        })
        .catch(error => {
          this.loading = false;
          console.error('region.requestFunction-error:', error);
          // this.$snotify.error('Get region list failed', 'Error!')
        });
    },

    //function for report generation API

    getGeneratedReports() {
      if (
        this.user.roleName == 'Sales Manager' ||
        this.user.roleName == 'Report Staff'
      ) {
        console.log('entred');
        this.loading = true;
        const params = {};
        params.$limit = 1;
        if (this.user.roleName == 'GA Head') {
          params.regionRegionManager = this.user._id;
        }

        this.$reportgenerationDataRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              this.generatedReportCount = res.data.docs.length;
            }
          })
          .catch(error => {
            this.loading = false;
            console.error('report.requestFunction-error:', error);
            // this.$snotify.error('Get report list failed', 'Error!')
          });
      }
    },

    getScheduledReport() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      this.$schedulereportDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.scheduleReportCount = res.data.docs.length;
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('report.requestFunction-error:', error);
          // this.$snotify.error('Get report schedule list failed', 'Error!')
        });
    },

    //function  for sales data API

    getSalesData() {
      if (
        this.user.roleName == 'Sales Manager' ||
        this.user.roleName == 'Report Staff' ||
        this.user.roleName == 'Sales Representative'
      ) {
        this.loading = true;
        const params = {};
        params.$limit = 1;
        if (this.user.roleName == 'GA Head') {
          this.parameters.regionRegionManager = this.user._id;
        }
        this.$salesdataDataRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              this.salesDataCount = res.data.docs.length;
            }
          })
          .catch(error => {
            this.loading = false;
            console.error('report.requestFunction-error:', error);
            // this.$snotify.error('Get sales data failed', 'Error!')
          });
      }
    },

    getSchedulesExpiry() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      this.$reportScheduleReminderDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.schedulesExpiryCount = res.data.docs.length;
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('report.requestFunction-error:', error);
          // this.$snotify.error('Get schedules failed', 'Error!')
        });
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>

<style scoped>
.dash-box {
  padding: 10px;
}

p {
  font-size: 12px;
  font-weight: bolder;
  line-height: 1;
}

.number {
  font-size: 40px;
}

.panel-footer {
  text-align: center;
}

.bg-primary {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
}

.panel-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 8px;
}

.positive {
  color: green;
}

.negative {
  color: red;
}

.total_investment_wrp {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.tablewrp {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.teext{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// dashboard.vue?39c9e804